import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  WarehouseService,
  WarehouseContainerModel, 
  Pagination
} from 'blg-akaun-ts-lib';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../visa';
@Component({
  selector: 'select-warehouse-drop-down',
  templateUrl: './select-warehouse-drop-down.component.html',
  styleUrls: ['./select-warehouse-drop-down.component.css']
})
export class SelectWarehouseDropDownComponent implements OnInit, OnDestroy {

  @Input() warehouseControl: FormControl;
  @Input() label: any;

  @Output() selectionChange = new EventEmitter();

  private subs = new SubSink();
  private apiVisa = AppConfig.apiVisa;
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<WarehouseContainerModel[]> = new ReplaySubject<WarehouseContainerModel[]>(1);
  entityList: WarehouseContainerModel[];
  fieldLabel: string;

  constructor( private warehouseService: WarehouseService ) {}

  ngOnInit() {
    this.fieldLabel = this.label;
    
  
    let pagination = new Pagination(0, 300, [{columnName: 'calcTotalRecords', operator: '=', value: 'true'}])
    this.subs.sink = this.warehouseService.getByCriteria(pagination, this.apiVisa).subscribe(
      {next: resolve => {
        this.entityList = resolve.data;
        this.filteredOptions$.next(this.entityList);
      }});

    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterWarehouse(resolve)});
  }

  filterWarehouse(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.entityList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.entityList.filter(c => c.bl_wms_warehouse_hdr.title.toLocaleLowerCase().includes(search) || c.bl_wms_warehouse_hdr.code.toLocaleLowerCase().includes(search)  );
      this.filteredOptions$.next(filter);
    }

  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}

